import { createFileRoute } from '@tanstack/react-router'

import { ConfirmacaoPorClique } from '@/components/gestor/recuperacao/ConfirmacaoPorClique'

function ConfirmarEmail() {
  return (
    <ConfirmacaoPorClique
      confirmacao="email-de-recuperacao"
      id="titulo-confirmar-email"
      titulo="Confirmar o e-mail de recuperação"
      texto="Este endereço foi cadastrado para receber o link de senha caso você perca o acesso ao e-mail de login. Confirme só se o cadastro foi seu."
      botao="Confirmar este e-mail"
      sucesso="E-mail confirmado. Ele já pode receber o link de senha."
    />
  )
}

/*
 * `/gestor/confirmar-email#t=…`: tela pública aberta pelo link do e-mail de
 * recuperação. Abrir não confirma nada; o botão confirma.
 */
export const Route = createFileRoute('/gestor/confirmar-email')({ component: ConfirmarEmail })
